import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../store';
import { dbLoadPublicTestimonials } from '../lib/db';
import './landing.css';

const calColors = [
  'rgba(10,138,82,.20)',
  'rgba(10,138,82,.40)',
  'rgba(214,68,79,.20)',
  'rgba(10,138,82,.15)',
  'rgba(10,138,82,.55)',
  'var(--s3)',
  'rgba(10,138,82,.35)',
  'rgba(214,68,79,.30)',
  'rgba(10,138,82,.20)',
  'var(--s3)',
  'rgba(10,138,82,.50)',
  'var(--s3)',
  'rgba(10,138,82,.15)',
  'rgba(10,138,82,.40)',
  'rgba(214,68,79,.15)',
  'var(--s3)',
  'rgba(10,138,82,.35)',
  'rgba(10,138,82,.20)',
  'var(--s3)',
  'rgba(10,138,82,.60)',
  'rgba(214,68,79,.25)',
  'rgba(10,138,82,.15)',
  'rgba(10,138,82,.40)',
  'var(--s3)',
  'rgba(10,138,82,.35)',
  'rgba(10,138,82,.20)',
  'var(--s3)',
  'rgba(214,68,79,.40)',
];

const ICONS = {
  import: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  ),
  analytics: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  calendar: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  shield: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  building: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <path d="M9 22V12h6v10" />
      <path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M15 11h.01" />
    </svg>
  ),
  playbook: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  ),
  replay: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="5,3 19,12 5,21 5,3" />
    </svg>
  ),
  list: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  export: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  trending: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </svg>
  ),
} as const;

/* ── Translations ─────────────────────────────────────────── */
const T = {
  he: {
    nav: {
      features: 'פיצ׳רים',
      pricing: 'מחירים',
      tools: 'כלים',
      testimonials: 'המלצות',
      faq: 'שאלות',
      blog: 'בלוג',
      signin: 'התחבר',
      start: 'התחל בחינם',
    },
    badge: 'תוכנית חינם זמינה',
    h1a: 'לסחור כמו מקצוען,',
    h1b: 'לתעד כמו מכונה.',
    heroSub:
      'יומן המסחר האוטומטי המתקדם ביותר לסוחרים בחוזים עתידיים. לעקוב אחרי כל עסקה, לשלוט בפסיכולוגיה, ולחדד את האדג׳ שלך.',
    ctaPrimary: 'התחל בחינם',
    ctaDemo: 'Live Demo',
    importsFrom: 'סנכרון אוטומטי מ-',
    featuresTitle: 'כלים שעובדים בשבילך',
    featuresSub: 'כל מה שצריך כדי לנתח, להשתפר ולשלוט בביצועי המסחר שלך.',
    card1Title: 'ייבוא אוטומטי',
    card1Desc:
      'סנכרן את נתוני הביצוע מ-TopstepX בלחיצה אחת. ייבוא CSV מכל ברוקר (Tradovate, NinjaTrader, Rithmic ועוד). בלי הקלדה ידנית, בלי טעויות.',
    card2Title: 'Analytics מקצועי',
    card2Desc:
      '9 גרפים מתקדמים כולל השוואת אסטרטגיות: Equity Curve, Drawdown, Heatmap, R:R Scatter ועוד — בזמן אמת.',
    card3Title: 'לוח שנה ויזואלי',
    card3Desc: 'זהה דפוסים בביצועים שלך. ראה באילו ימים אתה מצטיין ואילו סשנים עדיף להימנע מהם.',
    advTitle: 'Pro-level tools',
    advSub: 'בנוי לסוחרים רציניים שצריכים כלי דיוק לניהול סיכונים והערכות Prop Firm.',
    adv1Title: 'ניהול סיכונים מתקדם',
    adv1Desc: 'מחשבון R:R מדויק לכל חוזה עתידי. מעקב בזמן אמת אחרי Max Drawdown, הפסד יומי וחשיפה.',
    adv2Title: 'Prop HQ',
    adv2Desc:
      'ניטור חשבונות Prop בזמן אמת: Drawdown נותר, יעד רווח, וסטטוס Active / Warning / Danger — כרטיס אחד לכל חשבון.',
    adv3Title: '50+ חוזים עתידיים',
    adv3Desc: 'NQ, ES, CL, GC, SI ועוד — עם Point Values מדויקים לכל סמל לחישוב R:R אוטומטי.',
    adv4Title: 'ייצוא PDF ו-CSV',
    adv4Desc: 'ייצא דוחות מקצועיים לשיתוף עם מנטור, מוסד מימון, או לארכיון אישי.',
    adv5Title: 'השוואת אסטרטגיות',
    adv5Desc:
      'עקומות הון נפרדות לכל אסטרטגיה, WR%, Profit Factor ו-P&L ממוצע — כדי לדעת בדיוק מה עובד.',
    phqTitle: 'Prop HQ — מרכז הפיקוד שלך',
    phqSub:
      'ניטור חשבונות Prop בזמן אמת. מאזן, רצפה, יעד ו-Drawdown — כרטיס אחד לכל חשבון, הכל בדף אחד.',
    phqBadge: 'Prop Firm',
    phq1: 'תמונת מצב: הון כולל, P&L משולב, Funded / In Eval',
    phq2: 'מצב חשבון: מאזן, רצפה, יעד ו-Drawdown נותר לכל חשבון',
    phq3: 'סטטוס בזמן אמת: Active / Warning / Danger / Breached',
    phq4: 'תמיכה ב-Trailing EOD, Trailing Intraday ו-Static Drawdown',
    phqBtn: 'נסה את Prop HQ',
    bizTitle: 'Business Manager — ניהול עסקי',
    bizSub:
      'הכנסות ממשיכות, הוצאות תיקי מבחן, רווח נקי. תקציב חודשי ויומן עסקאות — חשבונאות אמיתית לטריידרים.',
    bizBadge: 'חדש',
    biz1: 'כרטיס P&L: רווח נקי, הכנסות ממשיכות, הוצאות תיקי מבחן',
    biz2: 'מדדים עסקיים: CPA ואורך חיי חשבון ממוצע',
    biz3: 'תקציב הוצאות חודשי עם מד ויזואלי',
    biz4: 'היסטוריית עסקאות: משיכות, תיקי מבחן, ריסטים',
    bizBtn: 'נסה את Business Manager',
    playbookTitle: 'Playbook — ספריית הסטאפים שלך',
    playbookSub:
      'בנה ועקוב אחרי כל סטאפ שאתה סוחר. הגדר כללי כניסה, יציאה וסיכון, מדוד WR ו-Expectancy לכל סטאפ, וקבל החלטות מבוססות נתונים.',
    playbookBadge: 'חדש',
    pb1: 'Win Rate, Expectancy ועקומת הון לכל סטאפ',
    pb2: 'כללי כניסה/יציאה/סיכון עם רשימת בדיקה לפני כל עסקה',
    pb3: 'תמיכה בריבוי סמלים — ES, NQ, MNQ ועוד בסטאפ אחד',
    pb4: 'Pre-Trade Checklist: כמה כללים עברו לפני כניסה לעסקה',
    pbBtn: 'נסה את Playbook',
    replayTitle: 'Trade Replay — חי מחדש כל עסקה',
    replaySub:
      'צפה בעסקאות שלך מתנגנות בר-אחרי-בר על גרפים אמיתיים. זהה בדיוק היכן היה השיא, איפה יצאת מוקדם מדי, ומה ניתן לשפר.',
    replayBadge: 'Replay',
    rp1: 'גרפים אמיתיים OHLC — 1m, 5m, 15m',
    rp2: 'סמני כניסה, יציאה ו-MFE על הגרף',
    rp3: 'Peak Unrealized P&L אוטומטי לכל עסקה',
    rp4: 'ציר זמן אירועים: מגמה, כניסה, שיא, יציאה',
    rpBtn: 'נסה Trade Replay',
    coachTitle: 'המאמן — פסיכולוגיית מסחר שנמדדת בכסף',
    coachSub:
      'המאמן סורק את היסטוריית המסחר שלך, מאתר בדיוק איפה הכסף דולף — מסחר נקמה, מסחר יתר, הגדלת סיכון אחרי הפסד — ובונה לך תרגילי משמעת שנמדדים אוטומטית על העסקאות האמיתיות שלך.',
    coachBadge: 'חדש',
    co1: 'אבחון דליפות התנהגותיות מדורג לפי עלות בדולרים',
    co2: 'תרגילי משמעת: צינון אחרי הפסד, מקס׳ עסקאות ביום ועוד',
    co3: 'עמידה בכללים נמדדת אוטומטית מהעסקאות — אי אפשר לזייף',
    co4: 'סולם דרגות משמעת: ממתחיל ועד מאסטר',
    coachBtn: 'נסה את המאמן',
    riskBadge: 'שולחן הסיכונים',
    riskTitle: 'להישאר ממומן',
    riskSub:
      'המעבר הוא החלק הקל. 90% מהסוחרים שורפים את החשבון הממומן בחודש הראשון. שולחן הסיכונים מחשב את ציון ההישרדות שלך — ההסתברות שהחשבון עוד יהיה ממומן — ומוריד אותך מהשולחן לפני שאתה שורף אותו.',
    rd1: 'ציון הישרדות: הסיכוי שהחשבון עוד ממומן, לפי איך שאתה באמת סוחר',
    rd2: 'כל דליפה מתורגמת ל-% מכרית הביטחון — לא רק לדולרים',
    rd3: 'אבחון "הכסף נהיה אמיתי": ההתנהגות שלך באבל מול מימון',
    rd4: 'התראת בזמן-אמת שמורידה אותך מהשולחן לפני פריצת הדרון',
    riskBtn: 'גלה את ציון ההישרדות שלך',
    econTitle: 'יומן כלכלי — דע מתי השוק זז',
    econSub:
      'כל אירועי המאקרו בעלי ההשפעה הגבוהה במקום אחד, באזור הזמן שלך. אנחנו אפילו מסמנים את האירועים שנופלים בשעות המסחר הפעילות שלך — כדי שלא תיכנס לעסקה רגע לפני נתון שמזיז את השוק.',
    econBadge: 'חדש · חינם',
    ec1: 'אירועי מאקרו בהשפעה גבוהה ובינונית',
    ec2: 'מסונן לשווקים המרכזיים (US, EU, GB, JP ועוד)',
    ec3: 'מותאם לאזור הזמן שלך',
    ec4: 'מדגיש אירועים בשעות המסחר הפעילות שלך',
    econBtn: 'התחל בחינם',
    mentorTitle: 'גישת מנטור — הוא רואה הכל, לקריאה בלבד',
    mentorSub:
      'הזמן מנטור לפי אימייל. הוא נכנס למערכת עם החשבון שלו ורואה את היומן שלך בדיוק כמו שאתה רואה אותו — אנליטיקס, Prop HQ, סטאפים ואפילו Trade Replay בר-אחרי-בר — הכל לקריאה בלבד. הוא לא יכול לערוך כלום, ואתה מבטל גישה בלחיצה.',
    mentorBadge: 'חדש · חינם',
    mt1: 'המנטור רואה את כל המערכת — לא רק תמונת מצב',
    mt2: 'כולל Trade Replay — נקודות כניסה ויציאה מדויקות',
    mt3: 'קריאה בלבד — אי אפשר לערוך את הנתונים שלך',
    mt4: 'הזמנה לפי אימייל · ביטול גישה בלחיצה',
    mentorBtn: 'התחל בחינם',
    feat8: 'המאמן — אבחון פסיכולוגי ותרגילי משמעת',
    pricingTitle: 'תמחור פשוט ושקוף',
    pricingSub: '14 יום Pro חינם, ללא כרטיס אשראי — שדרג כשתהיה מוכן.',
    planFree: 'חינם',
    planFreeSub: 'ללא כרטיס אשראי · לעולם',
    freeFeat1: 'תיעוד עסקאות ידני — ללא הגבלה',
    freeFeat2: 'לוח שנה ויזואלי — חודש נוכחי',
    freeFeat3: 'סטטיסטיקות בסיסיות יומיות',
    freeFeat4: 'ניהול חשבונות מרובים',
    freeFeat5: 'יומן כלכלי — אירועי מאקרו',
    freeFeat6: 'גישת מנטור (קריאה בלבד, לפי הזמנה)',
    freePlanBtn: 'התחל בחינם',
    planMonthly: 'Pro',
    planMonthlySub: '14 ימי ניסיון חינם · ללא כרטיס אשראי · ביטול בכל עת',
    feat1: 'הכל בחינם, בנוסף:',
    feat2: 'סנכרון אוטומטי: TopstepX · ייבוא CSV מכל ברוקר',
    feat3: 'Trade Replay — ריפליי בר-אחרי-בר',
    feat4: 'Playbook — ספריית סטאפים',
    feat5: 'Prop HQ + Business Manager',
    feat6: 'Analytics — 9 גרפים',
    feat7: 'ייצוא PDF/CSV · תמיכה בעדיפות',
    planBtn: 'שדרג ל-Pro',
    ctaTitle: 'מוכן לשפר את המסחר שלך?',
    ctaSub: 'התחל בחינם. שדרג ל-Pro בכל עת.',
    testimonialsTitle: 'מה הסוחרים אומרים',
    testimonials: [
      {
        name: 'אלון מ.',
        role: 'Topstep Funded Trader',
        text: 'TraderYo שינה לי לגמרי את האופן שבו אני מנהל את החשבונות שלי. ה-Drawdown Tracker מציל אותי מהפרת כללים כל יום.',
      },
      {
        name: 'יעל כ.',
        role: 'NQ Day Trader',
        text: 'הייתי עובד עם Excel. עכשיו אני רואה את כל ה-Analytics שלי בלחיצה אחת — עברתי מניחושים לידיעה בדיוק אילו סשנים להימנע מהם.',
      },
      {
        name: 'רועי ש.',
        role: 'Apex Futures Trader',
        text: 'הייבוא האוטומטי מ-TopstepX חוסך לי 30 דקות כל יום. המידע מדויק ומסודר בדיוק כמו שצריך.',
      },
    ],
    faqTitle: 'שאלות נפוצות',
    faqs: [
      {
        q: 'מה כוללת התוכנית החינמית?',
        a: 'התוכנית החינמית כוללת תיעוד עסקאות ידני ללא הגבלה, לוח שנה ויזואלי, סטטיסטיקות בסיסיות, ניהול חשבונות מרובים, יומן כלכלי וגישת מנטור (קריאה בלבד) — לעולם, ללא כרטיס אשראי. בנוסף, כל משתמש חדש מקבל 14 ימי ניסיון Pro מלאים (ללא כרטיס). כדי לקבל סנכרון אוטומטי, Trade Replay, Playbook, Prop HQ ואנליטיקס מלא לאחר מכן — שדרג ל-Pro.',
      },
      {
        q: 'האם TraderYo תומך בחשבונות מרובים?',
        a: 'כן. ניתן להוסיף חשבונות Live, Prop Firm, Sim ולעקוב אחריהם בנפרד — כל אחד עם יתרה, P&L ו-Drawdown משלו.',
      },
      {
        q: 'מאיזה ברוקרים אפשר לייבא עסקאות?',
        a: 'תומכים בסנכרון אוטומטי מ-TopstepX. ניתן לייבא CSV ידנית מכל ברוקר (Tradovate, NinjaTrader, Rithmic ועוד). סנכרון אוטומטי דורש תוכנית Pro. סנכרון Tradovate מושהה כרגע.',
      },
      {
        q: 'האם יש תמיכה ב-Prop Firm Trailing Drawdown?',
        a: 'כן. TraderYo מחשב Trailing Drawdown (EOD ו-Intraday), Daily Loss Limit ו-Profit Target בדיוק מלא. דורש תוכנית Pro.',
      },
      {
        q: 'האם הנתונים שלי מאובטחים?',
        a: 'כל הנתונים מאוחסנים בצורה מוצפנת ב-Supabase עם Row-Level Security. רק אתה יכול לראות את הנתונים שלך.',
      },
      {
        q: 'האם ניתן לבטל בכל עת?',
        a: 'כן. ניתן לבטל מנוי בכל עת ישירות מהחשבון, ללא עמלות ביטול.',
      },
    ],
    footerTerms: 'תנאי שימוש',
    footerPrivacy: 'פרטיות',
    footerAccess: 'נגישות',
    footerRisk: 'גילוי סיכונים',
    footerCookies: 'הגדרות עוגיות',
    footerCopy: (y: number) => `© ${y} TraderYo. כל הזכויות שמורות.`,
    footerDisclaimer:
      'TraderYo הוא כלי לתיעוד ואנליזה של מסחר. התוכן באתר הוא מידע כללי בלבד ואינו מהווה ייעוץ השקעות, שיווק השקעות או המלצה לפעולה. מסחר בחוזים עתידיים כרוך בסיכון לאובדן הון.',
    footerQuickTitle: 'קישורים מהירים',
    footerQuickLinks: [
      { label: "פיצ'רים", href: '#features' },
      { label: 'פלטפורמות וברוקרים', href: '#brokers' },
      { label: 'מחירים', href: '#pricing' },
      { label: 'שאלות ותשובות', href: '#faq' },
    ],
    footerUsefulTitle: 'קישורים שימושיים',
    footerUsefulLinks: [
      { label: 'בלוג', href: '/blog' },
      { label: 'מדריכים', href: '/guides' },
      { label: 'כללי חברות מימון', href: '/prop-firms' },
      { label: 'שאלות נפוצות', href: '#faq' },
      { label: 'תנאי שימוש', href: '/terms' },
      { label: 'מדיניות פרטיות', href: '/privacy' },
      { label: 'Risk Disclosure', href: '/risk-disclosure' },
    ],
    footerContactTitle: 'צור קשר',
    footerEmail: 'support@traderyo.com',
  },
  en: {
    nav: {
      features: 'Features',
      pricing: 'Pricing',
      tools: 'Tools',
      testimonials: 'Reviews',
      faq: 'FAQ',
      blog: 'Blog',
      signin: 'Sign in',
      start: 'Start free',
    },
    badge: 'Free plan available',
    h1a: 'Trade like a pro,',
    h1b: 'analyze like a machine',
    heroSub:
      'The most advanced trading journal for futures traders. Track every trade, master your psychology, and sharpen your edge.',
    ctaPrimary: 'Start for free',
    ctaDemo: 'Live demo',
    importsFrom: 'Auto-sync from',
    featuresTitle: 'Tools that work for you',
    featuresSub:
      'Everything you need to analyze, improve, and take control of your trading performance.',
    card1Title: 'Automated Trade Import',
    card1Desc:
      'Sync your execution data from TopstepX in one click. CSV import from any broker (Tradovate, NinjaTrader, Rithmic and more). No manual entry, no errors.',
    card2Title: 'Professional Analytics',
    card2Desc:
      '9 advanced charts including strategy comparison: Equity Curve, Drawdown, Heatmap, R:R scatter and more — in real time.',
    card3Title: 'Visual Trading Calendar',
    card3Desc:
      'Identify patterns in your performance. See which days you excel and which sessions to avoid.',
    advTitle: 'Pro-level tools',
    advSub:
      'Built for serious traders who need precision tools for risk management and Prop Firm evaluations.',
    adv1Title: 'Advanced Risk Management',
    adv1Desc:
      'Precise R:R calculator for every futures contract. Real-time tracking of Max Drawdown, Daily Loss, and exposure.',
    adv2Title: 'Prop HQ',
    adv2Desc:
      'Real-time prop account monitoring: drawdown buffer, profit target, and live status (Active / Warning / Danger) — one card per account.',
    adv3Title: '50+ Futures Contracts',
    adv3Desc:
      'NQ, ES, CL, GC, SI and more — with exact Point Values per symbol for automatic R:R calculations.',
    adv4Title: 'PDF & CSV Export',
    adv4Desc:
      'Export professional reports for sharing with a mentor, funding institution, or personal archive.',
    adv5Title: 'Strategy Comparison',
    adv5Desc:
      'Separate equity curves per strategy, WR%, Profit Factor and avg P&L side by side — so you know exactly what works.',
    phqTitle: 'Prop HQ — Your Prop Trading Command Center',
    phqSub:
      'Real-time monitoring of all your prop accounts. Balance, floor, target, and drawdown buffer — one card per account, everything on one page.',
    phqBadge: 'Prop Firm',
    phq1: 'Portfolio strip: total capital, combined P&L, Funded vs. In Eval',
    phq2: 'Account card: balance, floor, target, and drawdown per account',
    phq3: 'Live status: Active, Warning, Danger, or Breached',
    phq4: 'Trailing EOD, Trailing Intraday, and Static drawdown modes',
    phqBtn: 'Try Prop HQ',
    bizTitle: 'Business Manager — Track Your P&L as a Business',
    bizSub:
      'Revenue from payouts, expenses from challenge fees, net profit. Monthly budget, transaction history, and key business metrics — real accounting for prop traders.',
    bizBadge: 'New',
    biz1: 'Dark P&L card: net profit, payout revenue, and challenge expenses',
    biz2: 'Business metrics: cost per account (CPA) and average account lifespan',
    biz3: 'Monthly expense budget with visual gradient progress bar',
    biz4: 'Transaction log: payouts, challenge fees, and account resets',
    bizBtn: 'Try Business Manager',
    playbookTitle: 'Playbook — Your Trading Strategy Library',
    playbookSub:
      'Build and track every setup you trade. Define entry, exit, and risk rules, measure win rate and expectancy per setup, and make data-driven decisions.',
    playbookBadge: 'New',
    pb1: 'Per-setup win rate, expectancy, and equity curve',
    pb2: 'Entry, exit & risk rules with pre-trade checklist',
    pb3: 'Multi-symbol support — trade ES, NQ, MNQ and more in one setup',
    pb4: 'Pre-Trade Checklist: see how many rules pass before you enter',
    pbBtn: 'Try Playbook',
    replayTitle: 'Trade Replay — Relive Every Trade on Real Charts',
    replaySub:
      'Watch your trades play out bar-by-bar on real market data. Pinpoint exactly where you left money on the table — and what to fix next time.',
    replayBadge: 'Replay',
    rp1: 'Real OHLC bars — 1m, 5m, 15m timeframes',
    rp2: 'Entry, exit and MFE markers directly on the chart',
    rp3: 'Automatic Peak Unrealized P&L (MFE) for every trade',
    rp4: 'Event timeline: trend, entry, peak and exit moments',
    rpBtn: 'Try Trade Replay',
    coachTitle: 'The Coach — Trading Psychology, Measured in Dollars',
    coachSub:
      'The Coach scans your trade history, pinpoints exactly where your money leaks — revenge trading, overtrading, sizing up after losses — and assigns discipline drills scored automatically against your real trades.',
    coachBadge: 'New',
    co1: 'Behavioral leak diagnosis, ranked by dollar cost',
    co2: 'Discipline drills: cooldown after loss, max trades per day, and more',
    co3: 'Compliance scored automatically from real trades — impossible to fake',
    co4: 'Discipline rank ladder: Novice to Master',
    coachBtn: 'Try The Coach',
    riskBadge: 'The Risk Desk',
    riskTitle: 'Stay Funded',
    riskSub:
      'Getting funded is the easy part. 90% of traders blow the funded account in month one. The Risk Desk computes your Survival Score — the odds your account is still funded — and taps you out before you blow up.',
    rd1: 'Survival Score: the odds your account is still funded, from how you actually trade',
    rd2: 'Every leak repriced as a % of your drawdown buffer — not just dollars',
    rd3: 'The "money got real" diagnosis: your eval vs funded behaviour',
    rd4: 'Real-time tap-out that pulls you off the desk before a breach',
    riskBtn: 'See your Survival Score',
    econTitle: 'Economic Calendar — know when the market moves',
    econSub:
      'Every high-impact macro event in one place, in your timezone. We even highlight the events that land during your most active trading hours — so you never enter right before a number that moves the market.',
    econBadge: 'New · Free',
    ec1: 'High & medium-impact macro events',
    ec2: 'Filtered to the major markets (US, EU, GB, JP…)',
    ec3: 'Converted to your timezone',
    ec4: 'Highlights events during your trading hours',
    econBtn: 'Start for free',
    mentorTitle: 'Mentor Access — they see everything, read-only',
    mentorSub:
      "Invite a mentor by email. They sign in with their own account and see your journal exactly as you do — analytics, Prop HQ, setups, even bar-by-bar Trade Replay — all read-only. They can't change a thing, and you revoke access in one click.",
    mentorBadge: 'New · Free',
    mt1: 'Mentor sees the whole system — not just a snapshot',
    mt2: 'Includes Trade Replay — exact entry & exit points',
    mt3: 'Read-only — your data can never be edited',
    mt4: 'Invite by email · revoke access anytime',
    mentorBtn: 'Start for free',
    feat8: 'The Coach — psychology diagnosis + discipline drills',
    pricingTitle: 'Simple, transparent pricing',
    pricingSub: "14 days of Pro free, no credit card — upgrade when you're ready.",
    planFree: 'Free',
    planFreeSub: 'No credit card · forever',
    freeFeat1: 'Manual trade logging — unlimited',
    freeFeat2: 'Visual calendar — current month',
    freeFeat3: 'Basic daily stats',
    freeFeat4: 'Multiple trading accounts',
    freeFeat5: 'Economic calendar — macro events',
    freeFeat6: 'Mentor access (read-only, invite by email)',
    freePlanBtn: 'Get started free',
    planMonthly: 'Pro',
    planMonthlySub: '14-day free trial · no credit card · cancel anytime',
    feat1: 'Everything in Free, plus:',
    feat2: 'Auto-sync: TopstepX · CSV import from any broker',
    feat3: 'Trade Replay — bar-by-bar',
    feat4: 'Playbook — setup library',
    feat5: 'Prop HQ + Business Manager',
    feat6: 'Analytics — 9 charts',
    feat7: 'PDF/CSV export · Priority support',
    planBtn: 'Upgrade to Pro',
    ctaTitle: 'Ready to level up your trading?',
    ctaSub: 'Start free. Upgrade to Pro anytime.',
    testimonialsTitle: 'What traders are saying',
    testimonials: [
      {
        name: 'Alon M.',
        role: 'Topstep Funded Trader',
        text: 'TraderYo completely changed how I manage my accounts. The Drawdown Tracker saves me from violating rules every single day.',
      },
      {
        name: 'Yael K.',
        role: 'NQ Day Trader',
        text: 'I used to live in Excel. Now I see all my analytics in one click — went from guessing to knowing exactly which sessions to avoid.',
      },
      {
        name: 'Roee S.',
        role: 'Apex Futures Trader',
        text: 'Auto-import from TopstepX saves me 30 minutes every day. The data is accurate and organized exactly as needed.',
      },
    ],
    faqTitle: 'Frequently asked questions',
    faqs: [
      {
        q: "What's included in the free plan?",
        a: 'The free plan includes unlimited manual trade logging, a visual calendar, basic daily stats, multiple account management, an economic calendar, and read-only mentor access — forever, no credit card required. Plus, every new user gets a full 14-day Pro trial (no card). To keep auto-sync, Trade Replay, Playbook, Prop HQ, and full analytics afterward, upgrade to Pro.',
      },
      {
        q: 'Does TraderYo support multiple accounts?',
        a: 'Yes. You can add Live, Prop Firm, and Sim accounts and track them separately — each with its own balance, P&L, and drawdown.',
      },
      {
        q: 'Which brokers can I import trades from?',
        a: 'We support automatic sync from TopstepX. You can import CSV manually from any broker (Tradovate, NinjaTrader, Rithmic, and more). Auto-sync requires a Pro plan. Tradovate auto-sync is paused for now.',
      },
      {
        q: 'Does it support Prop Firm Trailing Drawdown?',
        a: 'Yes. TraderYo calculates Trailing Drawdown (EOD and Intraday), Daily Loss Limit, and Profit Target with full precision. Requires Pro plan.',
      },
      {
        q: 'Is my data secure?',
        a: 'All data is stored encrypted in Supabase with Row-Level Security. Only you can access your data.',
      },
      {
        q: 'Can I cancel at any time?',
        a: 'Yes. You can cancel your subscription anytime directly from your account, with no cancellation fees.',
      },
    ],
    footerTerms: 'Terms',
    footerPrivacy: 'Privacy',
    footerAccess: 'Accessibility',
    footerRisk: 'Risk Disclosure',
    footerCookies: 'Cookie Settings',
    footerCopy: (y: number) => `© ${y} TraderYo. All rights reserved.`,
    footerDisclaimer:
      'TraderYo is a trade journaling and analytics tool. Content on this site is general information only and is not investment advice, investment marketing, or a recommendation to take action. Trading futures involves risk of capital loss.',
    footerQuickTitle: 'Quick Links',
    footerQuickLinks: [
      { label: 'Features', href: '#features' },
      { label: 'Platforms & Brokers', href: '#brokers' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'FAQ', href: '#faq' },
    ],
    footerUsefulTitle: 'Useful Links',
    footerUsefulLinks: [
      { label: 'Blog', href: '/blog' },
      { label: 'Guides', href: '/guides' },
      { label: 'Prop Firm Rules', href: '/prop-firms' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Risk Disclosure', href: '/risk-disclosure' },
    ],
    footerContactTitle: 'Contact',
    footerEmail: 'support@traderyo.com',
  },
};

export default function Landing() {
  const navigate = useNavigate();
  const { loadDemoData, setUser, lang, setLang } = useStore();
  const isHe = lang === 'he';
  const t = isHe ? T.he : T.en;
  const dir = isHe ? 'rtl' : 'ltr';

  const goAuth = () => navigate('/auth');
  const goWhop = () => navigate('/auth?next=subscribe');

  // Real, owner-approved testimonials captured via the in-app NPS prompt. When
  // we have at least two, they replace the static marketing copy (genuine social
  // proof beats placeholders); otherwise fall back to the curated defaults.
  const [realTestimonials, setRealTestimonials] = useState<
    { text: string; name: string; role: string }[]
  >([]);
  const [videoOpen, setVideoOpen] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    dbLoadPublicTestimonials(6)
      .then((rows) =>
        setRealTestimonials(
          rows
            .filter((r) => r.comment)
            .map((r) => ({
              text: r.comment,
              name: r.display_name || (isHe ? 'סוחר/ת ב-TraderYo' : 'TraderYo trader'),
              role: isHe ? 'משתמש מאומת' : 'Verified user',
            })),
        ),
      )
      .catch(() => {});
  }, [isHe]);
  const testimonials = realTestimonials.length >= 2 ? realTestimonials : t.testimonials;

  const handleDemo = () => {
    loadDemoData();
    setUser({ id: 'demo', name: 'Demo User', email: 'demo@tradelog.app' });
    navigate('/dashboard');
  };

  // Task 2: Nav scroll behavior
  useEffect(() => {
    const nav = document.querySelector('.lp-nav') as HTMLElement | null;
    const container = document.querySelector('.lp') as HTMLElement | null;
    if (!nav || !container) return;
    const onScroll = () => {
      if (container.scrollTop > 80) {
        nav.classList.add('lp-nav-scrolled');
        nav.classList.remove('lp-nav-transparent');
      } else {
        nav.classList.remove('lp-nav-scrolled');
        nav.classList.add('lp-nav-transparent');
      }
    };
    onScroll();
    container.addEventListener('scroll', onScroll, { passive: true });
    return () => container.removeEventListener('scroll', onScroll);
  }, []);

  // Task 4: Trust stat counter animation
  useEffect(() => {
    const counters = document.querySelectorAll<HTMLElement>('[data-count]');
    if (!counters.length) return;
    const duration = 1800;
    const delay = 800;
    const frameIds: number[] = [];

    const run = (el: HTMLElement) => {
      const target = parseInt(el.dataset.count ?? '0', 10);
      const start = performance.now();
      const tick = (now: number) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * target) + (progress >= 1 ? '+' : '');
        if (progress < 1) {
          const id = requestAnimationFrame(tick);
          frameIds.push(id);
        }
      };
      const id = requestAnimationFrame(tick);
      frameIds.push(id);
    };

    const timer = setTimeout(() => counters.forEach(run), delay);
    return () => {
      clearTimeout(timer);
      frameIds.forEach(cancelAnimationFrame);
    };
  }, []);

  // Task 7: Scroll reveal animations
  useEffect(() => {
    const els = document.querySelectorAll('.lp-reveal');
    if (!els.length) return;
    const root = document.querySelector('.lp') as HTMLElement | null;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('lp-visible');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, root },
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [lang]);

  return (
    <div className="lp" dir={dir}>
      {/* Nav — always LTR internally for layout */}
      <header className="lp-nav" dir="ltr">
        <div className="lp-nav-inner">
          <a className="lp-logo" href="/">
            <img
              src="/logo-sm.webp"
              alt="TraderYo"
              style={{ height: 56, width: 56, objectFit: 'contain', borderRadius: 10 }}
            />
          </a>
          <nav>
            <ul className="lp-nav-links">
              <li>
                <a href="#features">{t.nav.features}</a>
              </li>
              <li>
                <a href="#pricing">{t.nav.pricing}</a>
              </li>
              <li>
                <a href="#advanced">{t.nav.tools}</a>
              </li>
              <li>
                <a href="#testimonials">{t.nav.testimonials}</a>
              </li>
              <li>
                <a href="#faq">{t.nav.faq}</a>
              </li>
              <li>
                <a href="/blog">{t.nav.blog}</a>
              </li>
            </ul>
          </nav>
          <div className="lp-nav-actions">
            {/* Language toggle */}
            <button
              onClick={() => setLang(isHe ? 'en' : 'he')}
              style={{
                background: '#ece9ff',
                border: '1.5px solid #d4d0f7',
                borderRadius: 999,
                padding: '4px 11px',
                color: '#4a3fe0',
                fontSize: '.72rem',
                fontWeight: 800,
                cursor: 'pointer',
                letterSpacing: '.06em',
                transition: 'background .15s, box-shadow .15s',
                boxShadow: '0 1px 2px rgba(10,18,48,.06)',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.background = '#ddd8ff';
                (e.currentTarget as HTMLButtonElement).style.boxShadow =
                  '0 4px 10px -4px rgba(99,91,255,.30)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.background = '#ece9ff';
                (e.currentTarget as HTMLButtonElement).style.boxShadow =
                  '0 1px 2px rgba(10,18,48,.06)';
              }}
            >
              {isHe ? 'EN' : 'עב'}
            </button>
            <button className="lp-btn-ghost" onClick={goAuth}>
              {t.nav.signin}
            </button>
            <button className="lp-btn-primary" onClick={goAuth}>
              {t.nav.start}
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero — Studio Mix */}
        <section className="lp-hero">
          <div className="lp-hero-bg" />
          <div className="lp-hero-inner">
            <div className="lp-badge">
              <div className="lp-badge-dot" />
              <span>
                {isHe ? '14 ימי ניסיון Pro · ללא כרטיס אשראי' : '14-day Pro trial · no credit card'}
              </span>
            </div>

            <h1>
              {isHe ? (
                <>
                  הופכים נתונים לרווחיות.
                  <br />
                  <span className="accent">Advanced Futures Journal.</span>
                </>
              ) : (
                <>
                  The <span className="accent">futures</span> journal
                  <br />
                  built to make you better.
                </>
              )}
            </h1>

            <p className="lp-hero-lede">
              {isHe
                ? 'עקוב אחרי כל עסקה, שלוט בכללי ה-Prop Firm שלך, ומצא את האדג׳ — בנוי אך ורק לחוזים עתידיים.'
                : 'Track every trade, monitor your prop firm rules, and find your edge — built exclusively for futures, not bolted on.'}
            </p>

            <div className="lp-hero-ctas" dir="ltr">
              <button className="lp-btn-hero-primary" onClick={goAuth}>
                {t.ctaPrimary}
              </button>
              <button className="lp-btn-hero-secondary" onClick={handleDemo}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="10,8 16,12 10,16" fill="currentColor" stroke="none" />
                </svg>
                {t.ctaDemo}
              </button>
            </div>

            <div className="lp-no-cc">
              {isHe ? 'ללא כרטיס אשראי · גישה מיידית' : 'No credit card · Instant access'}
            </div>

            <div className="lp-trust-row" dir="ltr">
              <div className="lp-trust-stat">
                <div className="lp-trust-num green" data-count="500">
                  0
                </div>
                <div className="lp-trust-label">{isHe ? 'סוחרים פעילים' : 'Active traders'}</div>
              </div>
              <div className="lp-trust-stat">
                <div className="lp-trust-num" data-count="50">
                  0
                </div>
                <div className="lp-trust-label">{isHe ? 'חוזים עתידיים' : 'Futures contracts'}</div>
              </div>
              <div className="lp-trust-stat">
                <div className="lp-trust-num gold">4.9★</div>
                <div className="lp-trust-label">{isHe ? 'דירוג משתמשים' : 'User rating'}</div>
              </div>
              <div className="lp-trust-stat">
                <div className="lp-trust-num green">$0</div>
                <div className="lp-trust-label">{isHe ? 'להתחיל' : 'To start'}</div>
              </div>
            </div>
          </div>
        </section>

        {/* Demo video — self-hosted (no third-party iframe → no cookie-consent block) */}
        <section className="lp-video-band" id="demo-video">
          <div className="lp-video-wrap">
            <h2 className="lp-video-title">
              {isHe ? 'צפו ב-TraderYo בפעולה' : 'See TraderYo in action'}
            </h2>
            <p className="lp-video-sub">
              {isHe
                ? '90 שניות — מהיומן ועד מאמן ה-AI שמראה כמה כל הרגל עולה לך.'
                : '90 seconds — from the journal to the AI Coach that shows what every habit costs you.'}
            </p>
            <div className="lp-video-frame" dir="ltr">
              <video
                ref={videoRef}
                className="lp-video-el"
                src="/traderyo-demo.mp4"
                poster="/demo-poster.jpg"
                preload="none"
                playsInline
                controls={videoOpen}
              />
              {!videoOpen && (
                <button
                  className="lp-video-poster"
                  onClick={() => {
                    setVideoOpen(true);
                    videoRef.current?.play();
                  }}
                  aria-label={isHe ? 'נגן סרטון הדגמה' : 'Play demo video'}
                >
                  <span className="lp-video-play">
                    <svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor">
                      <polygon points="8,5 19,12 8,19" />
                    </svg>
                  </span>
                </button>
              )}
            </div>
          </div>
        </section>

        {/* Ticker — brokers & platforms */}
        <div className="lp-ticker-section" dir="ltr">
          <div className="lp-ticker-track">
            {[
              { name: 'TopstepX', sub: 'Auto-sync' },
              { name: 'Tradovate', sub: 'CSV import' },
              { name: 'Topstep', sub: 'Prop tracking' },
              { name: 'Apex Trader', sub: 'Prop tracking' },
              { name: 'MyFundedFutures', sub: 'Prop tracking' },
              { name: 'NinjaTrader', sub: 'CSV import' },
              { name: 'Rithmic', sub: 'CSV import' },
              { name: 'TradeStation', sub: 'CSV import' },
              { name: 'TopstepX', sub: 'Auto-sync' },
              { name: 'Tradovate', sub: 'CSV import' },
              { name: 'Topstep', sub: 'Prop tracking' },
              { name: 'Apex Trader', sub: 'Prop tracking' },
              { name: 'MyFundedFutures', sub: 'Prop tracking' },
              { name: 'NinjaTrader', sub: 'CSV import' },
              { name: 'Rithmic', sub: 'CSV import' },
              { name: 'TradeStation', sub: 'CSV import' },
            ].map((item, i) => (
              <div key={`${item.name}-${item.sub}-${i}`} className="lp-ticker-item">
                <div className="lp-ticker-dot" />
                {item.name}
                <span className="lp-ticker-sub">{item.sub}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Features */}
        <section className="lp-features" id="features">
          <div className="lp-features-inner">
            <h2 className="lp-reveal">{t.featuresTitle}</h2>
            <p className="sub lp-reveal">{t.featuresSub}</p>
            <div className="lp-features-grid">
              <div className="lp-card lp-reveal lp-reveal-d1">
                <div className="lp-card-icon">{ICONS.import}</div>
                <h3>{t.card1Title}</h3>
                <p>{t.card1Desc}</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                  {[85, 60, 92, 45, 78].map((w, i) => (
                    <div
                      key={i}
                      style={{
                        height: 5,
                        borderRadius: 3,
                        background: `rgba(10,138,82,${w / 130})`,
                        width: `${w}%`,
                      }}
                    />
                  ))}
                </div>
              </div>

              <div className="lp-card featured lp-reveal lp-reveal-d2">
                <div className="lp-card-icon">{ICONS.analytics}</div>
                <h3>{t.card2Title}</h3>
                <p>{t.card2Desc}</p>
                <div className="lp-metrics">
                  {[
                    { label: 'Profit Factor', val: '2.84' },
                    { label: 'Win Rate', val: '68%' },
                    { label: 'Avg R:R', val: '1.9' },
                    { label: 'Max DD', val: '-4.2%', red: true },
                  ].map((m) => (
                    <div key={m.label} className="lp-metric">
                      <div className="lp-metric-label">{m.label}</div>
                      <div className="lp-metric-val" style={m.red ? { color: '#d6444f' } : {}}>
                        {m.val}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lp-card lp-reveal lp-reveal-d3">
                <div className="lp-card-icon">{ICONS.calendar}</div>
                <h3>{t.card3Title}</h3>
                <p>{t.card3Desc}</p>
                <div className="lp-mini-cal">
                  {calColors.map((c, i) => (
                    <div key={i} className="lp-mini-day" style={{ background: c }} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Advanced */}
        <section className="lp-advanced" id="advanced">
          <div className="lp-advanced-inner">
            <h2 className="lp-reveal">{t.advTitle}</h2>
            <p className="sub lp-reveal">{t.advSub}</p>
            <div className="lp-adv-grid">
              {[
                { icon: ICONS.shield, title: t.adv1Title, desc: t.adv1Desc },
                { icon: ICONS.building, title: t.adv2Title, desc: t.adv2Desc },
                { icon: ICONS.list, title: t.adv3Title, desc: t.adv3Desc },
                { icon: ICONS.export, title: t.adv4Title, desc: t.adv4Desc },
                { icon: ICONS.trending, title: t.adv5Title, desc: t.adv5Desc },
              ].map((item, idx) => (
                <div key={idx} className={`lp-adv-item lp-reveal lp-reveal-d${(idx % 3) + 1}`}>
                  <div className="lp-adv-icon">{item.icon}</div>
                  <div>
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Prop HQ */}
        <section className="lp-business lp-prophq-section" id="prop-hq">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-phq-badge">{t.phqBadge}</div>
              <h2>{t.phqTitle}</h2>
              <p>{t.phqSub}</p>
              <ul className="lp-biz-features">
                <li>{t.phq1}</li>
                <li>{t.phq2}</li>
                <li>{t.phq3}</li>
                <li>{t.phq4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goWhop}>
                {t.phqBtn}
              </button>
            </div>

            {/* Prop HQ mockup — Studio Mix light style */}
            <div className="lp-phq-mockup" dir="ltr">
              {/* Gradient hero strip */}
              <div className="lp-phq-hero">
                <div
                  className="lp-phq-hero-blob"
                  style={{ right: -20, top: -20, width: 120, height: 120 }}
                />
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                  }}
                >
                  <div>
                    <div className="lp-phq-hero-label">TOTAL FUNDED · 30D</div>
                    <div className="lp-phq-hero-val">+$6,792</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div className="lp-phq-hero-label">NEXT PAYOUT</div>
                    <div className="lp-phq-hero-sub">in 4 days</div>
                  </div>
                </div>
                <div className="lp-phq-hero-stats">
                  {[
                    { l: 'FUNDED', v: '2 · $200k' },
                    { l: 'IN EVAL', v: '2 · $100k' },
                    { l: 'AVG D/D LEFT', v: '72%' },
                  ].map((s) => (
                    <div key={s.l} style={{ flex: 1 }}>
                      <div className="lp-phq-hero-label">{s.l}</div>
                      <div style={{ fontSize: '.72rem', fontWeight: 800, marginTop: 2 }}>{s.v}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Featured account card */}
              <div className="lp-phq-card">
                <div className="lp-phq-card-hdr">
                  <div className="lp-phq-avatar">LU</div>
                  <div>
                    <div className="lp-phq-acc-name">Lucid Eval 1</div>
                    <div className="lp-phq-acc-sub">Challenge · Trailing EOD · $50k</div>
                  </div>
                  <span className="lp-phq-pill-passed">✓ PASSED</span>
                </div>
                <div className="lp-phq-kpis">
                  {[
                    { l: 'Balance', v: '$55,212', c: '#0a1230' },
                    { l: 'Floor', v: '$53,212', c: '#d6444f' },
                    { l: 'Target', v: '$53,000', c: '#0a8a52' },
                  ].map((k) => (
                    <div key={k.l} className="lp-phq-kpi-tile">
                      <div className="lp-phq-kpi-l">{k.l}</div>
                      <div className="lp-phq-kpi-v" style={{ color: k.c }}>
                        {k.v}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="lp-phq-bar-hdr">
                  <span>Drawdown remaining</span>
                  <span style={{ color: '#0a8a52' }}>100% · $2,000</span>
                </div>
                <div className="lp-phq-track">
                  <div
                    className="lp-phq-fill"
                    style={{
                      width: '100%',
                      background: 'linear-gradient(90deg, #0a8a52, #4ade80)',
                    }}
                  />
                </div>
                <div className="lp-phq-bar-hdr" style={{ marginTop: 8 }}>
                  <span>Profit target</span>
                  <span style={{ color: '#635bff' }}>+$5,212 / $3,000 · PASSED</span>
                </div>
                <div className="lp-phq-track">
                  <div
                    className="lp-phq-fill"
                    style={{
                      width: '100%',
                      background: 'linear-gradient(135deg, #a78bfa 0%, #635bff 55%, #22d3ee 110%)',
                    }}
                  />
                </div>
              </div>

              {/* Mini accounts list */}
              <div className="lp-phq-accounts">
                {[
                  { name: 'Apex 50k · #A-882', status: 'live', pnl: '+$1,240', pct: 62 },
                  { name: 'FTMO 100k · Phase 2', status: 'active', pnl: '+$820', pct: 41 },
                  { name: 'Topstep 150k · #T-241', status: 'live', pnl: '-$180', pct: 8 },
                ].map((a, i) => (
                  <div key={i} className="lp-phq-acc-row">
                    <div
                      className="lp-phq-acc-dot"
                      style={{
                        background:
                          a.status === 'active'
                            ? '#635bff'
                            : a.pnl.startsWith('-')
                              ? '#d6444f'
                              : '#0a8a52',
                      }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: '.64rem',
                          fontWeight: 700,
                          color: '#0a1230',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {a.name}
                      </div>
                      <div className="lp-phq-acc-mini-track">
                        <div
                          className="lp-phq-acc-mini-fill"
                          style={{
                            width: `${a.pct}%`,
                            background: a.pct > 50 ? '#0a8a52' : a.pct > 20 ? '#f59e0b' : '#d6444f',
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: '.64rem',
                        fontWeight: 800,
                        color: a.pnl.startsWith('-') ? '#d6444f' : '#0a8a52',
                        fontVariantNumeric: 'tabular-nums',
                        flexShrink: 0,
                      }}
                    >
                      {a.pnl}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Business Manager */}
        <section className="lp-business" id="business">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-biz-badge">{t.bizBadge}</div>
              <h2>{t.bizTitle}</h2>
              <p>{t.bizSub}</p>
              <ul className="lp-biz-features">
                <li>{t.biz1}</li>
                <li>{t.biz2}</li>
                <li>{t.biz3}</li>
                <li>{t.biz4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goWhop}>
                {t.bizBtn}
              </button>
            </div>

            {/* Business Manager mockup — Studio Mix style matching StudioBusiness */}
            <div className="lp-biz-mockup" dir="ltr">
              {/* Dark P&L hero card */}
              <div className="lp-biz-hero-card">
                <div className="lp-biz-hero-blobs" />
                <div style={{ position: 'relative' }}>
                  <div className="lp-biz-hero-label">NET PROFIT · APR 2026</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginTop: 5 }}>
                    <div className="lp-biz-hero-val">+$3,830</div>
                    <span className="lp-biz-hero-pill">▲ 36%</span>
                  </div>
                  <div className="lp-biz-hero-split">
                    <div>
                      <div className="lp-biz-split-l">REVENUE</div>
                      <div className="lp-biz-split-v" style={{ color: '#4ade80' }}>
                        +$4,500
                      </div>
                    </div>
                    <div>
                      <div className="lp-biz-split-l">EXPENSES</div>
                      <div className="lp-biz-split-v" style={{ color: '#fb7185' }}>
                        −$670
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CPA + Avg Life */}
              <div className="lp-biz-metric-grid">
                {[
                  { l: 'COST PER ACCOUNT', v: '$335', s: 'CPA · trailing 30d' },
                  { l: 'AVG ACCOUNT LIFE', v: '42d', s: 'until breach' },
                ].map((m) => (
                  <div key={m.l} className="lp-biz-metric-card">
                    <div className="lp-biz-metric-l">{m.l}</div>
                    <div className="lp-biz-metric-v">{m.v}</div>
                    <div className="lp-biz-metric-s">{m.s}</div>
                  </div>
                ))}
              </div>

              {/* Budget bar */}
              <div className="lp-biz-budget">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}
                >
                  <div>
                    <div style={{ fontSize: '.68rem', fontWeight: 800, color: '#0a1230' }}>
                      Expense budget
                    </div>
                    <div style={{ fontSize: '.58rem', color: '#5b6485', marginTop: 1 }}>
                      Monthly · resets May 1
                    </div>
                  </div>
                </div>
                <div className="lp-biz-budget-kpis">
                  {[
                    { l: 'SPENT', v: '$244', up: false },
                    { l: 'BUDGET', v: '$1,000', up: false },
                    { l: 'REMAINING', v: '$756', up: true },
                  ].map((k) => (
                    <div key={k.l} className="lp-biz-budget-kpi">
                      <div className="lp-biz-budget-kpi-l">{k.l}</div>
                      <div className="lp-biz-budget-kpi-v" style={k.up ? { color: '#0a8a52' } : {}}>
                        {k.v}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="lp-biz-budget-track">
                  <div className="lp-biz-budget-fill" style={{ width: '24%' }} />
                </div>
                <div className="lp-biz-budget-foot">
                  <span style={{ color: '#0a8a52' }}>24% used</span>
                  <span>$244 / $1,000</span>
                </div>
              </div>

              {/* Recent transactions */}
              <div className="lp-biz-txns">
                {[
                  {
                    up: true,
                    label: 'Lucid Trading payout',
                    sub: 'Apr 28 · Bank transfer',
                    amt: '+$2,500',
                  },
                  {
                    up: false,
                    label: 'Apex 50k challenge fee',
                    sub: 'Apr 22 · One-time',
                    amt: '−$160',
                  },
                  { up: true, label: 'Topstep payout', sub: 'Apr 15 · ACH', amt: '+$2,000' },
                ].map((tx, i) => (
                  <div key={i} className="lp-biz-txn-row">
                    <div
                      className="lp-biz-txn-icon"
                      style={{
                        background: tx.up ? '#d8f1e3' : '#fde2e5',
                        color: tx.up ? '#086a3f' : '#a02835',
                      }}
                    >
                      {tx.up ? '↓' : '↑'}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '.66rem', fontWeight: 800, color: '#0a1230' }}>
                        {tx.label}
                      </div>
                      <div style={{ fontSize: '.58rem', color: '#5b6485', marginTop: 1 }}>
                        {tx.sub}
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: '.68rem',
                        fontWeight: 800,
                        color: tx.up ? '#0a8a52' : '#d6444f',
                        fontVariantNumeric: 'tabular-nums',
                        flexShrink: 0,
                      }}
                    >
                      {tx.amt}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Playbook */}
        <section className="lp-business" id="playbook">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-biz-badge">{t.playbookBadge}</div>
              <h2>{t.playbookTitle}</h2>
              <p>{t.playbookSub}</p>
              <ul className="lp-biz-features">
                <li>{t.pb1}</li>
                <li>{t.pb2}</li>
                <li>{t.pb3}</li>
                <li>{t.pb4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goWhop}>
                {t.pbBtn}
              </button>
            </div>

            {/* Playbook mockup */}
            <div className="lp-pb-mockup" dir="ltr">
              {/* Setup card */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: 16,
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px -8px rgba(10,18,48,0.10)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: 4,
                    background: 'oklch(0.65 0.18 240deg)',
                    borderRadius: '14px 0 0 14px',
                  }}
                />
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingLeft: 12 }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 12,
                      background: 'linear-gradient(135deg, #a78bfa, #635bff)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 22,
                      color: '#fff',
                      flexShrink: 0,
                    }}
                  >
                    ◆
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '.84rem', fontWeight: 800, color: '#0a1230' }}>
                      Opening Range Breakout
                    </div>
                    <div style={{ display: 'flex', gap: 4, marginTop: 4, flexWrap: 'wrap' }}>
                      {['ES', 'MES', 'NQ'].map((sym) => (
                        <span
                          key={sym}
                          style={{
                            fontSize: '.58rem',
                            fontWeight: 800,
                            color: '#4a3fe0',
                            background: '#ece9ff',
                            borderRadius: 5,
                            padding: '2px 6px',
                          }}
                        >
                          {sym}
                        </span>
                      ))}
                    </div>
                  </div>
                  <span
                    style={{
                      fontSize: '.6rem',
                      fontWeight: 700,
                      color: '#0a8a52',
                      background: '#d8f1e3',
                      borderRadius: 6,
                      padding: '2px 8px',
                      flexShrink: 0,
                    }}
                  >
                    ● Active
                  </span>
                </div>
                {/* Stats strip */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: 8,
                    marginTop: 14,
                    paddingLeft: 12,
                  }}
                >
                  {[
                    { l: 'WIN RATE', v: '72%', c: '#0a8a52' },
                    { l: 'EXPECTANCY', v: '+$180', c: '#0a1230' },
                    { l: 'TOTAL P&L', v: '+$4,320', c: '#0a8a52' },
                  ].map((s) => (
                    <div
                      key={s.l}
                      style={{ background: '#f5f4fb', borderRadius: 9, padding: '8px 10px' }}
                    >
                      <div
                        style={{
                          fontSize: '.52rem',
                          fontWeight: 800,
                          color: '#9aa0bc',
                          letterSpacing: '.06em',
                        }}
                      >
                        {s.l}
                      </div>
                      <div
                        style={{
                          fontSize: '.8rem',
                          fontWeight: 800,
                          color: s.c,
                          marginTop: 3,
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {s.v}
                      </div>
                    </div>
                  ))}
                </div>
                {/* Mini equity curve */}
                <div style={{ marginTop: 12, paddingLeft: 12 }}>
                  <svg width="100%" height="44" viewBox="0 0 260 44" preserveAspectRatio="none">
                    <polygon
                      points="0,40 22,34 44,32 66,24 88,26 110,16 132,18 154,10 176,7 198,4 220,2 242,1 260,0 260,44 0,44"
                      fill="rgba(10,138,82,0.08)"
                    />
                    <polyline
                      points="0,40 22,34 44,32 66,24 88,26 110,16 132,18 154,10 176,7 198,4 220,2 242,1 260,0"
                      fill="none"
                      stroke="#0a8a52"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Rules card */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: '14px 16px',
                  marginTop: 10,
                  boxShadow: '0 2px 10px -4px rgba(10,18,48,0.07)',
                }}
              >
                <div
                  style={{
                    fontSize: '.58rem',
                    fontWeight: 800,
                    letterSpacing: '.08em',
                    color: '#0a8a52',
                    marginBottom: 10,
                  }}
                >
                  ● ENTRY RULES
                </div>
                {[
                  'Wait for 9:30 AM opening bar to close',
                  'Price must break above 30-min high with momentum',
                  'Volume ≥ 1.5× 20-period average',
                ].map((rule, i) => (
                  <div
                    key={i}
                    style={{ display: 'flex', gap: 8, marginBottom: 7, alignItems: 'flex-start' }}
                  >
                    <span
                      style={{
                        fontSize: '.58rem',
                        color: '#9aa0bc',
                        fontWeight: 800,
                        minWidth: 14,
                        paddingTop: 1,
                      }}
                    >
                      {i + 1}.
                    </span>
                    <span style={{ fontSize: '.64rem', color: '#0a1230', lineHeight: 1.45 }}>
                      {rule}
                    </span>
                  </div>
                ))}
              </div>

              {/* Pre-trade checklist badge */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: 10,
                  background: '#ece9ff',
                  borderRadius: 12,
                  padding: '10px 14px',
                }}
              >
                <div style={{ fontSize: '.64rem', fontWeight: 800, color: '#4a3fe0' }}>
                  Pre-Trade Checklist
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  {[1, 1, 1, 0].map((pass, i) => (
                    <div
                      key={i}
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 6,
                        background: pass ? '#635bff' : '#e8e4f2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 11,
                        color: pass ? '#fff' : '#9aa0bc',
                      }}
                    >
                      {pass ? '✓' : '·'}
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: '.6rem', fontWeight: 700, color: '#635bff' }}>
                  3 / 4 passed
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trade Replay */}
        <section className="lp-business lp-prophq-section" id="replay">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-phq-badge">{t.replayBadge}</div>
              <h2>{t.replayTitle}</h2>
              <p>{t.replaySub}</p>
              <ul className="lp-biz-features">
                <li>{t.rp1}</li>
                <li>{t.rp2}</li>
                <li>{t.rp3}</li>
                <li>{t.rp4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goWhop}>
                {t.rpBtn}
              </button>
            </div>

            {/* Trade Replay mockup */}
            <div className="lp-replay-mockup" dir="ltr">
              {/* Chart card */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: '14px 16px',
                  boxShadow: '0 4px 20px -8px rgba(10,18,48,0.10)',
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}
                >
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: '.7rem', fontWeight: 800, color: '#0a1230' }}>
                      NQ · 5min
                    </span>
                    <span style={{ fontSize: '.58rem', color: '#9aa0bc' }}>Nov 14, 2024</span>
                  </div>
                  <div style={{ display: 'flex', gap: 4 }}>
                    {['1m', '5m', '15m'].map((tf) => (
                      <span
                        key={tf}
                        style={{
                          fontSize: '.6rem',
                          fontWeight: 700,
                          padding: '2px 7px',
                          borderRadius: 6,
                          background: tf === '5m' ? '#ece9ff' : '#f5f4fb',
                          color: tf === '5m' ? '#635bff' : '#9aa0bc',
                        }}
                      >
                        {tf}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Candlestick SVG chart */}
                <svg width="100%" height="110" viewBox="0 0 280 110" style={{ display: 'block' }}>
                  {/* Grid lines */}
                  {[22, 44, 66, 88].map((y) => (
                    <line
                      key={y}
                      x1="4"
                      y1={y}
                      x2="276"
                      y2={y}
                      stroke="#ede9f8"
                      strokeWidth="0.8"
                    />
                  ))}
                  {/* Bars — [bodyLeft, wickCx, wickTop, bodyTop, bodyBot, wickBot, isGreen] */}
                  {(
                    [
                      [6, 12, 78, 82, 92, 96, true],
                      [22, 28, 72, 76, 88, 92, true],
                      [38, 44, 76, 78, 86, 90, false],
                      [54, 60, 66, 70, 82, 86, true],
                      [70, 76, 54, 58, 72, 76, true], // ENTRY
                      [86, 92, 42, 46, 60, 64, true],
                      [102, 108, 46, 48, 56, 60, false],
                      [118, 124, 32, 36, 50, 54, true],
                      [134, 140, 20, 24, 38, 42, true],
                      [150, 156, 10, 14, 28, 32, true],
                      [166, 172, 6, 10, 22, 26, true],
                      [182, 188, 4, 8, 18, 22, true], // MFE peak
                      [198, 204, 12, 14, 26, 30, false],
                      [214, 220, 20, 22, 36, 40, false],
                      [230, 236, 28, 30, 44, 48, false],
                      [246, 252, 36, 38, 54, 58, false], // EXIT
                    ] as [number, number, number, number, number, number, boolean][]
                  ).map(([bl, cx, wt, bt, bb, wb, g], i) => {
                    const col = g ? '#0a8a52' : '#d6444f';
                    return (
                      <g key={i}>
                        <line x1={cx} y1={wt} x2={cx} y2={wb} stroke={col} strokeWidth="1.5" />
                        <rect
                          x={bl}
                          y={bt}
                          width="12"
                          height={Math.max(bb - bt, 2)}
                          fill={col}
                          rx="1.5"
                        />
                      </g>
                    );
                  })}
                  {/* Entry marker — triangle pointing up, below c4 wick (wb=76) */}
                  <line
                    x1="76"
                    y1="4"
                    x2="76"
                    y2="84"
                    stroke="#635bff"
                    strokeWidth="1"
                    strokeDasharray="3,2"
                    strokeOpacity="0.3"
                  />
                  <polygon points="76,84 70,93 82,93" fill="#635bff" />
                  <text x="63" y="104" fontSize="7" fill="#635bff" fontWeight="800">
                    ENTRY
                  </text>
                  {/* MFE dashed line — x=188, center of peak candle */}
                  <line
                    x1="188"
                    y1="0"
                    x2="188"
                    y2="110"
                    stroke="#f59e0b"
                    strokeWidth="1.2"
                    strokeDasharray="3,2"
                  />
                  <text x="191" y="13" fontSize="6.5" fill="#f59e0b" fontWeight="800">
                    MFE
                  </text>
                  {/* Exit marker — triangle pointing down, above c15 wick (wt=36) */}
                  <line
                    x1="252"
                    y1="28"
                    x2="252"
                    y2="110"
                    stroke="#d6444f"
                    strokeWidth="1"
                    strokeDasharray="3,2"
                    strokeOpacity="0.3"
                  />
                  <polygon points="252,28 246,19 258,19" fill="#d6444f" />
                  <text x="240" y="14" fontSize="7" fill="#d6444f" fontWeight="800">
                    EXIT
                  </text>
                </svg>

                {/* P&L HUD */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: 8,
                    marginTop: 12,
                  }}
                >
                  {[
                    { l: 'REALIZED', v: '+$340', c: '#0a8a52', bg: '#d8f1e3' },
                    { l: 'PEAK MFE', v: '+$520', c: '#92580c', bg: '#fef3c7' },
                    { l: 'DURATION', v: '14m', c: '#0a1230', bg: '#f5f4fb' },
                  ].map((k) => (
                    <div
                      key={k.l}
                      style={{
                        background: k.bg,
                        borderRadius: 9,
                        padding: '8px 10px',
                        textAlign: 'center',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '.52rem',
                          fontWeight: 800,
                          color: '#9aa0bc',
                          letterSpacing: '.06em',
                        }}
                      >
                        {k.l}
                      </div>
                      <div
                        style={{
                          fontSize: '.82rem',
                          fontWeight: 900,
                          color: k.c,
                          marginTop: 3,
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {k.v}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Event timeline */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: '14px 16px',
                  marginTop: 10,
                  boxShadow: '0 2px 10px -4px rgba(10,18,48,0.07)',
                }}
              >
                <div
                  style={{
                    fontSize: '.58rem',
                    fontWeight: 800,
                    letterSpacing: '.08em',
                    color: '#9aa0bc',
                    marginBottom: 12,
                  }}
                >
                  EVENT TIMELINE
                </div>
                {[
                  {
                    dot: '#635bff',
                    time: '09:31',
                    label: 'Opening range formed',
                    sub: 'HTF bias: bullish',
                  },
                  {
                    dot: '#0a8a52',
                    time: '09:35',
                    label: 'Entry — breakout confirmed',
                    sub: '+3 / 4 rules passed',
                  },
                  {
                    dot: '#f59e0b',
                    time: '09:44',
                    label: 'Peak MFE reached',
                    sub: 'Unrealized +$520',
                  },
                  {
                    dot: '#d6444f',
                    time: '09:49',
                    label: 'Exit — target hit',
                    sub: 'Realized +$340',
                  },
                ].map((ev, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      gap: 10,
                      marginBottom: i < 3 ? 10 : 0,
                      alignItems: 'flex-start',
                      position: 'relative',
                    }}
                  >
                    {i < 3 && (
                      <div
                        style={{
                          position: 'absolute',
                          left: 3.5,
                          top: 12,
                          bottom: -6,
                          width: 1,
                          background: '#e8e4f2',
                        }}
                      />
                    )}
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: ev.dot,
                        marginTop: 4,
                        flexShrink: 0,
                        position: 'relative',
                        zIndex: 1,
                      }}
                    />
                    <div>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
                        <span style={{ fontSize: '.58rem', color: '#9aa0bc', fontWeight: 700 }}>
                          {ev.time}
                        </span>
                        <span style={{ fontSize: '.64rem', color: '#0a1230', fontWeight: 700 }}>
                          {ev.label}
                        </span>
                      </div>
                      <div style={{ fontSize: '.58rem', color: '#9aa0bc', marginTop: 1 }}>
                        {ev.sub}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Economic Calendar */}
        <section className="lp-business lp-prophq-section" id="economic-calendar">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-phq-badge">{t.econBadge}</div>
              <h2>{t.econTitle}</h2>
              <p>{t.econSub}</p>
              <ul className="lp-biz-features">
                <li>{t.ec1}</li>
                <li>{t.ec2}</li>
                <li>{t.ec3}</li>
                <li>{t.ec4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goAuth}>
                {t.econBtn}
              </button>
            </div>

            {/* Economic calendar mockup */}
            <div className="lp-replay-mockup" dir="ltr">
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: 16,
                  boxShadow: '0 4px 20px -8px rgba(10,18,48,0.10)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 12,
                  }}
                >
                  <span style={{ fontSize: '.74rem', fontWeight: 800, color: '#0a1230' }}>
                    Today · Mon, Jun 15
                  </span>
                  <span style={{ fontSize: '.58rem', color: '#9aa0bc' }}>Asia/Jerusalem</span>
                </div>
                {/* "in your hours" highlight banner */}
                <div
                  style={{
                    background: 'linear-gradient(135deg, #a78bfa, #635bff)',
                    color: '#fff',
                    borderRadius: 10,
                    padding: '8px 12px',
                    fontSize: '.62rem',
                    fontWeight: 700,
                    marginBottom: 12,
                  }}
                >
                  ⚡ 2 high-impact events during your 15:00–16:00 window
                </div>
                {/* Event rows */}
                {(
                  [
                    ['15:30', 'USD', 'CPI m/m', 3, true],
                    ['15:30', 'USD', 'Core CPI m/m', 3, true],
                    ['17:00', 'EUR', 'ECB President Speaks', 2, false],
                    ['21:00', 'USD', 'FOMC Statement', 3, false],
                  ] as [string, string, string, number, boolean][]
                ).map(([time, cur, name, imp, hot], i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      padding: '8px 10px',
                      borderRadius: 9,
                      marginBottom: 6,
                      background: hot ? '#ece9ff' : '#f5f4fb',
                      border: hot ? '1px solid #d9d4ea' : '1px solid transparent',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '.62rem',
                        fontWeight: 800,
                        color: '#5b6485',
                        minWidth: 34,
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {time}
                    </span>
                    <span
                      style={{
                        fontSize: '.56rem',
                        fontWeight: 800,
                        color: '#4a3fe0',
                        background: '#fff',
                        borderRadius: 5,
                        padding: '2px 6px',
                        border: '1px solid #e8e4f2',
                      }}
                    >
                      {cur}
                    </span>
                    <span
                      style={{
                        fontSize: '.66rem',
                        fontWeight: 600,
                        color: '#0a1230',
                        flex: 1,
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {name}
                    </span>
                    <span style={{ display: 'flex', gap: 2 }}>
                      {[0, 1, 2].map((d) => (
                        <span
                          key={d}
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            background: d < imp ? (imp === 3 ? '#d6444f' : '#f59e0b') : '#e8e4f2',
                          }}
                        />
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Mentor Sharing */}
        <section className="lp-business" id="mentor-share">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-biz-badge">{t.mentorBadge}</div>
              <h2>{t.mentorTitle}</h2>
              <p>{t.mentorSub}</p>
              <ul className="lp-biz-features">
                <li>{t.mt1}</li>
                <li>{t.mt2}</li>
                <li>{t.mt3}</li>
                <li>{t.mt4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goAuth}>
                {t.mentorBtn}
              </button>
            </div>

            {/* Mentor share mockup */}
            <div className="lp-pb-mockup" dir="ltr">
              {/* Invite-by-email card */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: 16,
                  boxShadow: '0 4px 20px -8px rgba(10,18,48,0.10)',
                }}
              >
                <div
                  style={{
                    fontSize: '.62rem',
                    fontWeight: 800,
                    letterSpacing: '.06em',
                    color: '#9aa0bc',
                    marginBottom: 10,
                  }}
                >
                  🤝 MENTOR ACCESS
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                      fontSize: '.64rem',
                      color: '#5b6485',
                      background: '#f5f4fb',
                      border: '1px solid #d9d4ea',
                      borderRadius: 7,
                      padding: '8px 10px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    mentor@email.com
                  </div>
                  <span
                    style={{
                      fontSize: '.62rem',
                      fontWeight: 700,
                      color: '#fff',
                      background: 'linear-gradient(135deg, #a78bfa, #635bff)',
                      borderRadius: 999,
                      padding: '7px 14px',
                      flexShrink: 0,
                    }}
                  >
                    Invite
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8,
                    marginTop: 10,
                    padding: '7px 10px',
                    background: '#f5f4fb',
                    borderRadius: 8,
                  }}
                >
                  <span style={{ fontSize: '.64rem', color: '#0a1230', fontWeight: 600 }}>
                    coach@email.com
                  </span>
                  <span
                    style={{
                      fontSize: '.56rem',
                      fontWeight: 800,
                      color: '#0a8a52',
                      background: '#d8f1e3',
                      borderRadius: 999,
                      padding: '2px 8px',
                    }}
                  >
                    active
                  </span>
                </div>
              </div>

              {/* Read-only journal preview (what the mentor sees) */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: 16,
                  marginTop: 10,
                  boxShadow: '0 2px 10px -4px rgba(10,18,48,0.07)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}
                >
                  <span
                    style={{
                      fontSize: '.66rem',
                      fontWeight: 800,
                      color: '#fff',
                      background: 'linear-gradient(135deg, #a78bfa, #635bff)',
                      borderRadius: 999,
                      padding: '3px 10px',
                    }}
                  >
                    👁 Viewing alon_m · read-only
                  </span>
                </div>
                <svg width="100%" height="50" viewBox="0 0 260 50" preserveAspectRatio="none">
                  <polygon
                    points="0,44 26,38 52,40 78,30 104,32 130,22 156,24 182,14 208,10 234,5 260,2 260,50 0,50"
                    fill="rgba(99,91,255,0.10)"
                  />
                  <polyline
                    points="0,44 26,38 52,40 78,30 104,32 130,22 156,24 182,14 208,10 234,5 260,2"
                    fill="none"
                    stroke="#635bff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: 8,
                    marginTop: 10,
                  }}
                >
                  {[
                    { l: 'TRADES', v: '128' },
                    { l: 'WIN RATE', v: '64%' },
                    { l: 'W / L', v: '74 / 41' },
                  ].map((s) => (
                    <div
                      key={s.l}
                      style={{ background: '#f5f4fb', borderRadius: 9, padding: '8px 10px' }}
                    >
                      <div
                        style={{
                          fontSize: '.52rem',
                          fontWeight: 800,
                          color: '#9aa0bc',
                          letterSpacing: '.06em',
                        }}
                      >
                        {s.l}
                      </div>
                      <div
                        style={{
                          fontSize: '.8rem',
                          fontWeight: 800,
                          color: '#0a1230',
                          marginTop: 3,
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {s.v}
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginTop: 10,
                    fontSize: '.6rem',
                    fontWeight: 700,
                    color: '#4a3fe0',
                    background: '#ece9ff',
                    borderRadius: 8,
                    padding: '7px 10px',
                  }}
                >
                  ▶ Trade Replay included — see every entry & exit bar-by-bar
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* The Coach */}
        <section className="lp-business" id="coach">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-biz-badge">{t.coachBadge}</div>
              <h2>{t.coachTitle}</h2>
              <p>{t.coachSub}</p>
              <ul className="lp-biz-features">
                <li>{t.co1}</li>
                <li>{t.co2}</li>
                <li>{t.co3}</li>
                <li>{t.co4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goWhop}>
                {t.coachBtn}
              </button>
            </div>

            {/* Coach mockup */}
            <div className="lp-pb-mockup" dir="ltr">
              {/* Leak diagnosis card */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: 16,
                  boxShadow: '0 4px 20px -8px rgba(10,18,48,0.10)',
                }}
              >
                <div
                  style={{
                    fontSize: '.58rem',
                    fontWeight: 800,
                    letterSpacing: '.08em',
                    color: '#9aa0bc',
                    marginBottom: 12,
                  }}
                >
                  WHERE YOUR MONEY LEAKS
                </div>
                {[
                  {
                    rank: 1,
                    label: 'Revenge trading',
                    sub: '14 trades within 30 min of a loss',
                    cost: '-$2,140',
                    hot: true,
                  },
                  {
                    rank: 2,
                    label: 'Overtrading',
                    sub: 'Trades #4+ each day',
                    cost: '-$1,380',
                    hot: false,
                  },
                  {
                    rank: 3,
                    label: 'Sizing up after losses',
                    sub: 'Losses 48% larger after a loss',
                    cost: '-$920',
                    hot: false,
                  },
                ].map((leak) => (
                  <div
                    key={leak.rank}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      marginBottom: leak.rank < 3 ? 10 : 0,
                    }}
                  >
                    <div
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: '50%',
                        background: leak.hot ? '#fde2e5' : '#f5f4fb',
                        color: leak.hot ? '#d6444f' : '#5b6485',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 800,
                        fontSize: '.62rem',
                        flexShrink: 0,
                      }}
                    >
                      {leak.rank}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '.68rem', fontWeight: 800, color: '#0a1230' }}>
                        {leak.label}
                      </div>
                      <div style={{ fontSize: '.56rem', color: '#9aa0bc', marginTop: 1 }}>
                        {leak.sub}
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: '.7rem',
                        fontWeight: 800,
                        color: '#d6444f',
                        fontVariantNumeric: 'tabular-nums',
                        flexShrink: 0,
                      }}
                    >
                      {leak.cost}
                    </div>
                  </div>
                ))}
              </div>

              {/* Active drill card */}
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #e8e4f2',
                  borderRadius: 14,
                  padding: 16,
                  marginTop: 10,
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 2px 10px -4px rgba(10,18,48,0.07)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 4,
                    background: 'linear-gradient(135deg, #a78bfa 0%, #635bff 55%, #22d3ee 110%)',
                  }}
                />
                <div style={{ paddingLeft: 10 }}>
                  <div
                    style={{
                      fontSize: '.56rem',
                      fontWeight: 800,
                      letterSpacing: '.08em',
                      color: '#4a3fe0',
                    }}
                  >
                    YOUR CURRENT DRILL
                  </div>
                  <div
                    style={{ fontSize: '.78rem', fontWeight: 800, color: '#0a1230', marginTop: 3 }}
                  >
                    Cooldown after a loss
                  </div>
                  <div style={{ fontSize: '.62rem', color: '#5b6485', marginTop: 1 }}>
                    Wait 30 min after every loss before the next trade
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: '.6rem',
                      color: '#5b6485',
                      margin: '10px 0 5px',
                    }}
                  >
                    <span>14/20 trades</span>
                    <span style={{ fontWeight: 800, color: '#0a8a52' }}>93% compliant</span>
                  </div>
                  <div
                    style={{
                      height: 7,
                      borderRadius: 4,
                      background: '#eceaf5',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: '70%',
                        background: '#0a8a52',
                        borderRadius: 4,
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Rank badge */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: 10,
                  background: '#ece9ff',
                  borderRadius: 12,
                  padding: '10px 14px',
                }}
              >
                <div style={{ fontSize: '.64rem', fontWeight: 800, color: '#4a3fe0' }}>
                  Discipline Rank
                </div>
                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  {['Novice', 'Apprentice', 'Disciplined'].map((r, i) => (
                    <span
                      key={r}
                      style={{
                        fontSize: '.56rem',
                        fontWeight: 700,
                        padding: '2px 8px',
                        borderRadius: 999,
                        background: i === 2 ? '#635bff' : '#fff',
                        color: i === 2 ? '#fff' : '#9aa0bc',
                      }}
                    >
                      {r}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Risk Desk — Stay Funded */}
        <section className="lp-business lp-prophq-section" id="stay-funded">
          <div className="lp-business-inner">
            <div className="lp-business-text">
              <div className="lp-phq-badge">{t.riskBadge}</div>
              <h2>{t.riskTitle}</h2>
              <p>{t.riskSub}</p>
              <ul className="lp-biz-features">
                <li>{t.rd1}</li>
                <li>{t.rd2}</li>
                <li>{t.rd3}</li>
                <li>{t.rd4}</li>
              </ul>
              <button className="lp-btn-primary" onClick={goWhop}>
                {t.riskBtn}
              </button>
            </div>

            {/* Survival Score mockup — dark-luxe instrument */}
            <div className="lp-replay-mockup" dir="ltr">
              <div
                style={{
                  background: 'linear-gradient(165deg, #0e1330 0%, #0a0c1e 55%, #070710 100%)',
                  borderRadius: 18,
                  padding: '22px 20px 18px',
                  boxShadow: '0 24px 60px -24px rgba(99,91,255,0.45)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      'radial-gradient(360px 240px at 50% 8%, rgba(99,91,255,0.28), transparent 70%)',
                    pointerEvents: 'none',
                  }}
                />
                <div style={{ position: 'relative', textAlign: 'center' }}>
                  <div
                    style={{
                      fontSize: '.58rem',
                      fontWeight: 800,
                      letterSpacing: '.14em',
                      color: '#8b93c8',
                    }}
                  >
                    🎧 THE RISK DESK
                  </div>

                  <svg
                    width="200"
                    height="180"
                    viewBox="0 0 180 170"
                    style={{ margin: '6px auto 0', overflow: 'visible', display: 'block' }}
                  >
                    <defs>
                      <filter id="lp-rd-glow" x="-40%" y="-40%" width="180%" height="180%">
                        <feGaussianBlur stdDeviation="4" result="b" />
                        <feMerge>
                          <feMergeNode in="b" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                    </defs>
                    {/* tick scale */}
                    {Array.from({ length: 28 }, (_, i) => {
                      const a = ((135 + (i / 27) * 270) * Math.PI) / 180;
                      const major = i % 3 === 0;
                      const r0 = 70 + 11 / 2 + 6;
                      const r1 = r0 + (major ? 8 : 4);
                      return (
                        <line
                          key={i}
                          x1={90 + r0 * Math.cos(a)}
                          y1={90 + r0 * Math.sin(a)}
                          x2={90 + r1 * Math.cos(a)}
                          y2={90 + r1 * Math.sin(a)}
                          stroke="rgba(255,255,255,0.22)"
                          strokeWidth={major ? 2 : 1}
                          strokeLinecap="round"
                        />
                      );
                    })}
                    {/* track */}
                    <circle
                      cx="90"
                      cy="90"
                      r="70"
                      fill="none"
                      stroke="rgba(255,255,255,0.08)"
                      strokeWidth="11"
                      strokeLinecap="round"
                      strokeDasharray="329.9 439.8"
                      transform="rotate(135 90 90)"
                    />
                    {/* progress */}
                    <circle
                      cx="90"
                      cy="90"
                      r="70"
                      fill="none"
                      stroke="#635bff"
                      strokeWidth="11"
                      strokeLinecap="round"
                      strokeDasharray="234.2 439.8"
                      transform="rotate(135 90 90)"
                      filter="url(#lp-rd-glow)"
                    />
                    <circle
                      cx="148.5"
                      cy="51.6"
                      r="5.5"
                      fill="#fff"
                      stroke="#635bff"
                      strokeWidth="2.5"
                      filter="url(#lp-rd-glow)"
                    />
                    <text
                      x="90"
                      y="86"
                      textAnchor="middle"
                      style={{
                        fontSize: 46,
                        fontWeight: 800,
                        fill: '#fff',
                        letterSpacing: '-.03em',
                      }}
                    >
                      71
                    </text>
                    <text
                      x="90"
                      y="108"
                      textAnchor="middle"
                      style={{
                        fontSize: 12,
                        fontWeight: 800,
                        fill: '#6b73a8',
                        letterSpacing: '.16em',
                      }}
                    >
                      / 100
                    </text>
                  </svg>

                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                      padding: '4px 12px',
                      borderRadius: 999,
                      background: 'rgba(99,91,255,0.18)',
                      border: '1px solid rgba(99,91,255,0.5)',
                      marginTop: -4,
                    }}
                  >
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: 999,
                        background: '#635bff',
                        boxShadow: '0 0 8px #635bff',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '.56rem',
                        fontWeight: 800,
                        color: '#a9a4ff',
                        letterSpacing: '.1em',
                      }}
                    >
                      STABLE · SURVIVAL SCORE
                    </span>
                  </div>
                  <div style={{ fontSize: '.6rem', color: '#9aa0c8', marginTop: 8 }}>
                    Odds this account is still funded in 120 days
                  </div>
                </div>

                {/* phase diagnosis strip */}
                <div
                  style={{
                    position: 'relative',
                    marginTop: 16,
                    paddingTop: 14,
                    borderTop: '1px solid rgba(255,255,255,0.08)',
                  }}
                >
                  <div
                    style={{
                      fontSize: '.52rem',
                      fontWeight: 800,
                      letterSpacing: '.1em',
                      color: '#ff8a93',
                      marginBottom: 8,
                    }}
                  >
                    ⚠ PHASE TRANSITION · EVAL vs FUNDED
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {[
                      { t: 'IN EVAL', a: '2.1', b: '1', accent: false },
                      { t: 'FUNDED', a: '4.8', b: '3', accent: true },
                    ].map((c, i) => (
                      <div key={c.t} style={{ display: 'contents' }}>
                        {i === 1 && (
                          <span
                            style={{
                              fontSize: '.66rem',
                              fontWeight: 800,
                              color: '#ff8a93',
                              flexShrink: 0,
                            }}
                          >
                            →
                          </span>
                        )}
                        <div
                          style={{
                            flex: 1,
                            background: 'rgba(255,255,255,0.04)',
                            border: `1px solid ${c.accent ? 'rgba(214,68,79,0.45)' : 'rgba(255,255,255,0.1)'}`,
                            borderRadius: 10,
                            padding: '8px 10px',
                          }}
                        >
                          <div
                            style={{
                              fontSize: '.5rem',
                              fontWeight: 800,
                              letterSpacing: '.08em',
                              color: c.accent ? '#ff8a93' : '#8b93c8',
                              marginBottom: 4,
                            }}
                          >
                            {c.t}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              fontSize: '.56rem',
                              color: '#c7cbe8',
                            }}
                          >
                            <span style={{ color: '#7077a6' }}>trades/day</span>
                            <b style={{ color: '#fff' }}>{c.a}</b>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              fontSize: '.56rem',
                              color: '#c7cbe8',
                              marginTop: 2,
                            }}
                          >
                            <span style={{ color: '#7077a6' }}>median size</span>
                            <b style={{ color: '#fff' }}>{c.b}</b>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="lp-pricing" id="pricing">
          <div className="lp-pricing-inner">
            <h2 className="lp-reveal">{t.pricingTitle}</h2>
            <p className="sub">{t.pricingSub}</p>
            <div className="lp-pricing-grid" dir="ltr">
              {/* Free tier */}
              <div className="lp-plan lp-plan-free lp-reveal">
                <div className="lp-plan-name">{t.planFree}</div>
                <div className="lp-plan-price">$0</div>
                <div className="lp-plan-sub">{t.planFreeSub}</div>
                <ul className="lp-plan-features" style={{ marginTop: 16 }}>
                  <li>{t.freeFeat1}</li>
                  <li>{t.freeFeat2}</li>
                  <li>{t.freeFeat3}</li>
                  <li>{t.freeFeat4}</li>
                  <li>{t.freeFeat5}</li>
                  <li>{t.freeFeat6}</li>
                </ul>
                <button
                  className="lp-plan-btn"
                  style={{ background: 'rgba(255,255,255,0.12)', color: '#fff', boxShadow: 'none' }}
                  onClick={goAuth}
                >
                  {t.freePlanBtn}
                </button>
                <div style={{ fontSize: '.72rem', marginTop: 10, textAlign: 'center' }}>
                  {isHe ? 'ללא כרטיס אשראי' : 'No credit card required'}
                </div>
              </div>

              {/* Pro tier */}
              <div className="lp-plan lp-reveal">
                <div className="lp-badge-pill">{isHe ? 'הכי פופולרי' : 'Most popular'}</div>
                <div className="lp-plan-name">{t.planMonthly}</div>
                <div className="lp-plan-price">
                  $21.99<span>/mo</span>
                </div>
                <div className="lp-plan-sub">{t.planMonthlySub}</div>
                <ul className="lp-plan-features" style={{ marginTop: 16 }}>
                  <li>
                    <strong>{t.feat1}</strong>
                  </li>
                  <li>{t.feat2}</li>
                  <li>{t.feat3}</li>
                  <li>{t.feat4}</li>
                  <li>{t.feat8}</li>
                  <li>{t.feat5}</li>
                  <li>{t.feat6}</li>
                  <li>{t.feat7}</li>
                </ul>
                <button className="lp-plan-btn" onClick={goWhop}>
                  {t.planBtn}
                </button>
                <div style={{ fontSize: '.72rem', marginTop: 10, textAlign: 'center' }}>
                  {isHe ? 'ביטול בכל עת' : 'Cancel anytime'}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="lp-testimonials" id="testimonials">
          <div className="lp-testimonials-inner">
            <h2 className="lp-reveal">{t.testimonialsTitle}</h2>
            <div className="lp-testimonials-grid">
              {testimonials.map((item, i) => (
                <div key={i} className={`lp-testimonial-card lp-reveal lp-reveal-d${i + 1}`}>
                  <div className="lp-testimonial-stars">★★★★★</div>
                  <p className="lp-testimonial-text">"{item.text}"</p>
                  <div className="lp-testimonial-author">
                    <div
                      className={`lp-testimonial-avatar ${i === 0 ? 'green' : i === 1 ? 'blue' : 'orange'}`}
                    >
                      {item.name[0]}
                    </div>
                    <div>
                      <div className="lp-testimonial-name">{item.name}</div>
                      <div className="lp-testimonial-role">{item.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="lp-faq" id="faq">
          <div className="lp-faq-inner">
            <h2>{t.faqTitle}</h2>
            <div className="lp-faq-list">
              {t.faqs.map((item, i) => (
                <details key={i} className="lp-faq-item">
                  <summary className="lp-faq-q">{item.q}</summary>
                  <p className="lp-faq-a">{item.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="lp-cta">
          <div className="lp-cta-inner">
            <h2>{t.ctaTitle}</h2>
            <p>{t.ctaSub}</p>
            <div className="lp-cta-btns" dir="ltr">
              <button className="lp-btn-hero-primary" onClick={goAuth}>
                {t.ctaPrimary}
              </button>
              <button className="lp-btn-hero-secondary" onClick={handleDemo}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="10,8 16,12 10,16" fill="currentColor" stroke="none" />
                </svg>
                {t.ctaDemo}
              </button>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="lp-footer">
        <div className="lp-footer-cols">
          {/* Quick Links */}
          <div className="lp-footer-col">
            <h4 className="lp-footer-col-title">{t.footerQuickTitle}</h4>
            <ul className="lp-footer-col-links">
              {t.footerQuickLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
          {/* Useful Links */}
          <div className="lp-footer-col">
            <h4 className="lp-footer-col-title">{t.footerUsefulTitle}</h4>
            <ul className="lp-footer-col-links">
              {t.footerUsefulLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
          {/* Contact */}
          <div className="lp-footer-col">
            <h4 className="lp-footer-col-title">{t.footerContactTitle}</h4>
            <ul className="lp-footer-col-links">
              <li>
                <a href={`mailto:${t.footerEmail}`} className="lp-footer-contact-row">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m2 7 10 7 10-7" />
                  </svg>
                  {t.footerEmail}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="lp-footer-bottom" style={{ direction: isHe ? 'rtl' : 'ltr' }}>
          <div className="lp-footer-logo">
            <img
              src="/logo-sm.webp"
              alt="TraderYo"
              style={{ height: 40, width: 40, objectFit: 'contain', borderRadius: 8 }}
            />
          </div>
          <div className="lp-footer-copy">{t.footerCopy(new Date().getFullYear())}</div>
          <ul className="lp-footer-links">
            <li>
              <a href="/terms">{t.footerTerms}</a>
            </li>
            <li>
              <a href="/privacy">{t.footerPrivacy}</a>
            </li>
            <li>
              <a href="/accessibility">{t.footerAccess}</a>
            </li>
            <li>
              <a href="/risk-disclosure">{t.footerRisk}</a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.dispatchEvent(new Event('open-cookie-settings'));
                }}
              >
                {t.footerCookies}
              </a>
            </li>
          </ul>
        </div>
        <div
          className="lp-footer-disclaimer"
          style={{
            direction: isHe ? 'rtl' : 'ltr',
            maxWidth: 760,
            margin: '14px auto 0',
            fontSize: 11,
            lineHeight: 1.6,
            color: 'var(--t3)',
            textAlign: 'center',
            opacity: 0.8,
          }}
        >
          {t.footerDisclaimer}
        </div>
      </footer>
    </div>
  );
}
